import { PageSliceType, ProductHeaderLink } from '@contracts';

interface SliceItem {
  slice_type?: string;
  items?: Array<{
    link_alias?: { text: string | null };
    [key: string]: any;
  }>;
  [key: string]: any;
}

export function mapPrismicLinkAlias(data: SliceItem[]): SliceItem[] {
  return data.map((item) => {
    const isEligibleItem =
      item.slice_type === PageSliceType.IconTextGrid ||
      item.slice_type === PageSliceType.IconDescriptionBoxes ||
      item.slice_type === PageSliceType.TextFeatureRow ||
      item.slice_type === PageSliceType.CaseStudySection ||
      item.slice_type === PageSliceType.LinkCarousel;

    if (isEligibleItem && Array.isArray(item.items)) {
      return {
        ...item,
        items: item.items.map((subItem) => {
          if ('link_alias' in subItem) {
            const { link_alias, ...rest } = subItem;
            return {
              ...rest,
              link: link_alias
            };
          }
          return subItem;
        })
      };
    }
    return item;
  });
}

interface ProductHeaderLinkAlias {
  link_alias: { text: string };
  text: { text: string };
}

export function mapPrismicHeaderLinksAlias(data: ProductHeaderLinkAlias[]): ProductHeaderLink[] {
  return data.map((item) => {
    if ('link_alias' in item) {
      const { link_alias, ...rest } = item;
      return {
        ...rest,
        link: link_alias
      };
    }
    return item;
  });
}
